<template>
    <!-- 上传文件 -->
    <el-dialog class="dialog" v-if="dialogPushFiles" title="批量推送" :visible.sync="dialogPushFiles" :close-on-click-modal="false" top="10vh" width="860px">
        <!-- 内容 -->
        <div class="list-box">
            <div class="list-left">
                <!-- 表头 -->
                <div class="list-item-heade">
                    <div class="title-box channel-title">
                        <span class="title">投放渠道</span>
                    </div>

                    <div class="title-box name-title">
                        <span class="title">账户名称</span>
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" v-if="dataList[0].search && dataList[0].list.length > 0">全选</el-checkbox>
                    </div>    
                </div>
                <!-- 列表内容 -->
                <div class="list-item list-left-item">
                    <el-tabs tab-position="left">
                        <el-tab-pane v-for="(item,index) in dataList" :key="index" :label="item.label" :disabled="item.disabled">
                            <el-input class="filter-item input_search" v-model="item.search" placeholder="帐户名称/账户ID搜索" clearable @input="handleSearch(item)" @clear="handleSearch(item)">
                                <svg-icon slot="prefix" class="el-input__icon icon" icon-class="search_shape" />
                            </el-input>
                            <div class="scrollbar-box">
                                <span class="tips" v-if="!listLoading && item.list.length == 0">暂无数据</span> 
                                <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="listLoading" v-else>
                                    <template v-for="(itemCheckbox, indexCheckbox) in item.list">
                                        <el-checkbox :key="indexCheckbox" v-model="itemCheckbox.checked" :label="itemCheckbox.advertiserId" @change="handleCheck($event,itemCheckbox)">
                                            <!-- <el-tooltip effect="dark" :content="itemCheckbox.name" placement="bottom" :visible-arrow="false" popper-class="tooltip"> -->
                                                <span :title="itemCheckbox.name + '  -- ' + itemCheckbox.advertiserId">{{itemCheckbox.name + '&nbsp;&nbsp;&nbsp;&nbsp;' + itemCheckbox.advertiserId}}</span>
                                            <!-- </el-tooltip> -->
                                        </el-checkbox>
                                    </template>
                                </el-scrollbar>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <div class="list-right">
                <div class="title-box">
                    <span class="title">已选账户</span>
                    <el-button type="text" :disabled="selectedList && selectedList.length == 0" @click="handleEmpty">清空</el-button>
                </div>

                <div class="list-item list-selected">
                    <el-scrollbar wrap-class="scrollbar-wrapper">
                        <div class="selected-item" v-for="(item,index) in selectedList" :key="index" >
                            <span class="text" :title="item.name + '  -- ' + item.advertiserId">{{item.name + '&nbsp;&nbsp;&nbsp;&nbsp;' + item.advertiserId}}</span>
                            <i class="el-icon-error icon" @click="handleDelete(item)"></i>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
        <!-- 按钮组 -->
        <div class="dialog-butn-box" style="margin: 30px 0 0">
            <el-button size="small" @click="dialogPushFiles = false">取 消</el-button>
            <el-button size="small" type="primary" :disabled="selectedList.length == 0" :loading="dialogLoading" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {advertiserIdList_ajax,pushFileToAds_ajax} from '@File~/api/file'
export default {
    data() {
        return {
            dialogPushFiles: false,
            dialogLoading:false,
            listLoading:false,
            dataList:[],
            selectedList:[], //已选中列表
            currentFile:{}, // 当前文件

            // 全选
            checkAll: false,
            isIndeterminate: false
        }
    },
    methods: {
        // 初始化
        init(currentFile) {
            this.dialogPushFiles = true
            this.dialogLoading = false
            
            this.currentFile = currentFile

            // console.log('当前文件：',this.currentFile)

            // 获取接口数据
            this.dataList = [
                {
                    id:1,
                    label:'巨量引擎',
                    disabled: false,
                    search:'',
                    originList:[],
                    list:[]
                },
                {
                    id:2,
                    label:'广点通',
                    disabled: true,
                    search:'',
                    originList:[],
                    list:[] 
                },
                {
                    id:3,
                    label:'快手',
                    disabled: true,
                    search:'',
                    originList:[],
                    list:[] 
                },
                {
                    id:4,
                    label:'Facebook',
                    disabled: true,
                    search:'',
                    originList:[],
                    list:[] 
                }
            ]
            // 已选中列表
            this.selectedList = []

            this.listLoading = true
            // 获取广告主ID列表
            advertiserIdList_ajax().then(response => {
                this.listLoading = false
                if(response.code == 1) {
                    // 目前只有巨量引擎
                    this.dataList[0].originList = response.data
                    this.dataList[0].originList.forEach(item => {
                        item.checked = false
                    })

                    this.dataList[0].list = this.dataList[0].originList
                }
            })
        },

        // 筛选
        handleSearch(item) {
            const search = item.search.toLowerCase().replace(/^\s*|\s*$/g,""); // 转小写 去两头空格
            // console.log('search值：',search)
            if(search) {
                item.list = item.originList.filter(item => String(item['name']).toLowerCase().indexOf(search) > -1 || String(item['advertiserId']).toLowerCase().indexOf(search) > -1)

                this.checkAllNmu() // 全选按钮状态
            } else {
                item.list = item.originList
            }
        },

        // 操作选择
        handleCheck(val,item) {
            // console.log(val,item.label,': ',item.checked)
            if(val) {
                this.selectedList.push(item)
            } else {
                this.selectedList.splice(this.selectedList.indexOf(item),1)
            }

            this.checkAllNmu() // 全选按钮状态
        },

        // 删除已选
        handleDelete(item) {
            item.checked = false
            this.selectedList.splice(this.selectedList.indexOf(item),1)
            this.checkAllNmu() // 全选按钮状态
        },

        // 清空
        handleEmpty() {
            this.selectedList.forEach(item => {
                item.checked = false
            })
            this.selectedList = []

            this.checkAllNmu() // 全选按钮状态
        },

        // 确定
        handleSave() {
            this.dialogLoading = true
            let advertiserId = []
            this.selectedList.forEach(item => {
                advertiserId.push(item.advertiserId)
            })
            const data = {
                userId: this.$store.getters.userId,
                advertiserIds: advertiserId,
                adsType: 1, // 广告类型：1:头条;2:广点通;3:快手;4:facebook
                fileId: this.currentFile.id,
            }

            // console.log('推送参数：',data)

            pushFileToAds_ajax(data).then(response => {
                this.dialogLoading = false
                if(response.code == 1) {
                    this.$message({
                        type: 'success',
                        message: '推送中。。。'
                    });
                    this.dialogPushFiles = false
                }
            })
        },

        // 全选
        handleCheckAllChange(val) {
            if(val) {
                this.dataList[0].list.forEach(item => {
                    if(!item.checked) { // 没被选中
                        item.checked = true
                        this.selectedList.push(item)
                    }
                })
            } else {
                this.dataList[0].list.forEach(item => {
                    if(item.checked) {
                        item.checked = false
                        this.selectedList.splice(this.selectedList.indexOf(item),1)
                    }
                })
            }

            this.checkAllNmu() // 全选按钮状态
        },

        // 全选按钮状态
        checkAllNmu() {
            let num = 0
            this.dataList[0].list.forEach(item => {
                if(!item.checked) { // 没被选中
                    num += 1
                }
            })

            if(num == 0) {
                this.checkAll = true
                this.isIndeterminate = false
            } else if(num == this.dataList[0].list.length ){ // 全没被选
                this.checkAll = false
                this.isIndeterminate = false
            } else if(num > 0 && num < this.dataList[0].list.length) {
                this.checkAll = false
                this.isIndeterminate = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .dialog{
        ::v-deep.el-dialog{
            border-radius: 4px;
            height: calc(100vh - 20vh);
            overflow: hidden;
        }
        ::v-deep.el-dialog__header{
            padding: 23px 32px 21px;
        }
        ::v-deep.el-dialog__title{
            color: #333333;
        }
        ::v-deep.el-dialog__headerbtn{
            font-size: 24px;
        }

        ::v-deep.el-dialog__body{
            position: relative;
            padding: 16px 32px 23px;
        }

        .list-box{
            height: calc(100vh - 20vh - 169px);
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: flex-start;
            .list-left{
                width: 500px;
                border: 1px solid #E5E5E5;
            }
            .list-right{
                width: 280px;
                border: 1px solid #E5E5E5;
            }
            .list-item-heade{
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: flex-start;
                .channel-title{
                    width: 270px;
                   border-right: 1px solid#EEEEEE;
                }
            }
            .title-box{
                width: 100%;
                height: 44px;
                padding: 0 20px;
                background: #F7F7F7;
                box-shadow: 0px -1px 0px 0px #EEEEEE;
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: center;
                .title{
                    color: #999999;
                    font-weight: 600;
                }
            }
            .list-item{
                padding: 0 10px 8px;
                height: calc(100vh - 20vh - 212px);
                .selected-item{
                    height: 32px;
                    line-height: 32px;
                    padding: 0 12px;
                    margin-top: 8px;
                    background: rgba($color:#3A89FF, $alpha: .15);
                    border-radius: 4px;

                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: space-between;
                    align-items: center;

                    .text{
                        flex-grow: 1;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        cursor: pointer;
                    }
                    .icon{
                        flex-grow:0;
                        font-size: 15px;
                        color:#999999;
                        cursor: pointer;
                    }

                }
            }
            .list-left-item{
                padding: 0;
                ::v-deep.el-tabs{
                    height: 100%;
                }
                ::v-deep.el-tabs__header{
                    width: 180px;
                    margin-right: 0;
                }
                ::v-deep.el-tabs__content{
                    height: 100%;
                    .el-tab-pane{
                        height: 100%;
                    }
                    .scrollbar-box{
                        margin-top: 4px;
                        height: calc(100% - 40px);
                        width: 100%;
                        overflow: hidden;
                    }
                }
                ::v-deep.el-tabs--left .el-tabs__item.is-left{
                    text-align: left;
                }
                ::v-deep.el-tabs__item{
                    // color: #666666;
                }
                ::v-deep.el-tabs__item.is-active{
                    background: #F0F6FF;
                    color: #3a89ff;
                }
                ::v-deep.el-tabs--left .el-tabs__nav-wrap.is-left::after{
                    width: 1px; 
                    z-index: 9999;
                }
                ::v-deep.el-tabs__nav-wrap::after{
                   background-color: #e5e5e5; 
                }
                ::v-deep.el-tabs__active-bar{
                    background-color: #e5e5e5
                }

                ::v-deep.el-checkbox{
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    margin-right: 0;
                    padding: 0 20px;
                    box-shadow: 0px -1px 0px 0px #EEEEEE;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    .el-checkbox__label{
                        display: inline;
                        color: #666666;
                    }
                    .el-checkbox__inner{
                        width: 16px;
                        height: 16px;
                        border: 1px solid #E5E5E5;
                        &::after{
                            left: 5px;
                            top: 2px;
                        }
                    }
                }
            }

            .list-selected{
                padding: 0 0px 8px 10px;
                .selected-item{
                   margin-right: 10px; 
                }
            }

        }

        // 滚动条
        .scrollbar-wrapper {
            overflow-x: hidden !important;
            width: 100%;
        }

        ::v-deep .el-scrollbar__wrap {
            // width: 100%;
            overflow-x: hidden !important;
        }

        .el-scrollbar__bar.is-vertical {
            right: 0px;
        }

        .el-scrollbar {
            height: 100%;
        }
        
    }

     // input search
    .input_search{
        width: 100%;
        ::v-deep .el-input__inner{
            padding-left: 44px;
            border-radius: 0;
            border-right: 0;
            border-left: 0;
        }
        ::v-deep .el-input__prefix{
            width: 20px;
            height: 20px;
            margin:8px 12px 8px 12px;
            .icon{
                width: 20px;
                height: 20px;
            }
        }
    }

    .tips{
        display: flex;
        flex-flow: column;
        justify-content: center;
        height: calc(100% - 40px);
        text-align: center;
        font-size: 14px;
        color: #909399;
    }
</style>